import './icon.less'
import "./common.less"



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/style/index.js